/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum DATA_FORMAT {
	COPY_PASTE = "application/vnd.adapptio.copy-paste",
}

export enum DATA_FORMAT_COMPAT {
	HAE_COPY_PASTE = "application/hae.copy-paste",
}
